import $ from 'jquery';

const elementSelector = '.component-ume-video';

class VideoOverlay {
  constructor(element) {
    this.$element = element;
    this.isOpen = false;

    this.attachEvents();
  }

  attachEvents() {
    this.$element.click(() => {
      this.close();
    });

    this.$element.find('iframe').click((event) => {
      event.stopPropagation();
    });
  }

  open() {
    if (this.isOpen) {
      return;
    }

    this.$element.addClass('open');
    this.isOpen = true;

    this.$element.find('iframe').each(function reloadVideoSource() {
      this.src = $(this).data('src');
    });
  }

  close() {
    if (this.isOpen === false) {
      return;
    }

    this.$element.removeClass('open');
    this.isOpen = false;

    this.$element.find('iframe').each(function removeVideoSource() {
      this.src = '';
    });
  }
}

export default function initializeVideoOverlay() {
  $(`${elementSelector}`).each(function handleVideoElement() {
    const overlay = new VideoOverlay($(this).find(`${elementSelector}__overlay`).first());

    $(this).find(`${elementSelector}__wrapper`).click(() => {
      overlay.open();
    });
  });
}
